<template>
  <div class="electiveCosmetRegister">
    <div class="nav">
      <div class="title">
        <i class="iconfont icon-yuyue"></i>
        <p>美容/治疗预约</p>
      </div>
      <div class="line"></div>
      <div class="main">
        <el-form :inline="true" :model="cosmetRegistration" class="demo-form-inline">
          
          <!-- 手动输入，可以记忆
          <el-col :span="8">
            <el-form-item label="治疗项目">
              <el-autocomplete
                class="popInput"
                v-model="cosmetRegistration.operation_name"
                :fetch-suggestions="operationnamelist"
                placeholder="请输入项目名称"
                @blur="saveSuggesion(6)"
                @focus="updateLocal(6)"
              ></el-autocomplete>
            </el-form-item>
          </el-col> -->

          <!-- 从后台读取项目名称，下拉菜单 -->
          <el-col :span="8">
            <el-form-item label="治疗项目">
              <!-- <el-select v-model="cosmetRegistration.operation_name"   placeholder="--下拉选择项目名称--" > -->
              <el-select v-model="cosmetRegistration.operation_name"   placeholder="--下拉选择项目名称--"  :disabled="operationElectiveId?true:false">
                <el-option v-for="(cvalue, ckey) in operation_names"  v-bind:key="ckey"
                  :label="cvalue" 
                  :value="cvalue">
                </el-option>                
              </el-select>  
              <!-- <span v-show="hasOperationNum>0" class="now_operation">已预约{{hasOperationNum}}</span>             -->
            </el-form-item>
          </el-col>



          <el-col :span="8">
            <!-- <el-form-item label="治疗部位">
              <el-cascader
                class="operationPosition"
                placeholder="---选择检查部位---"
                v-model="cosmetRegistration.operation_position_new"
                :options="positionOption"
                :props="{ multiple: true, checkStrictly: false }"
                clearable
              ></el-cascader>
            </el-form-item> -->
            <el-form-item label="治疗部位">
              <el-autocomplete
                class="popInput"
                v-model="cosmetRegistration.operation_position_new"
                :fetch-suggestions="operationpositionlist"
                placeholder="请输入部位"
                @blur="saveSuggesion(10)"
                @focus="updateLocal(10)"
              ></el-autocomplete>
            </el-form-item>            
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="高危因素">
              <el-select v-model="cosmetRegistration.high_risk_factor" size="small">
                <el-option
                  v-for="item in heightRisk"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
          <el-col :span="8">
            <el-form-item label="首诊医生">
              <el-autocomplete
                class="popInput"
                v-model="cosmetRegistration.sign_doctor"
                :fetch-suggestions="signdoctorlist"
                placeholder="请输入内容"
                @blur="saveSuggesion(0)"
                @focus="updateLocal(0)"
              ></el-autocomplete>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-col :span="8">
              <el-form-item class="operation_date" label="治疗日期">
                <el-date-picker
                  v-model="cosmetRegistration.operation_date"
                  type="date"
                  @change="saveSuggesion(7)"
                  @focus="updateLocal(7)"
                  placeholder="选择日期"
                ></el-date-picker>
                <!-- <span v-show="(hasOperationNum[0]+hasOperationNum[1])>0" class="now_operation">已预约:上午:{{hasOperationNum[0]}} | 下午:{{hasOperationNum[1]}}</span> -->
                <span v-show="true" class="now_operation">已预约:上午:{{hasOperationNum[0]}}  下午:{{hasOperationNum[1]}}</span>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="治疗时段">
                <el-select v-model="cosmetRegistration.am_pm"   placeholder="--下拉选择时段--" >
                  <el-option label="上午" value="am"></el-option>
                  <el-option label="下午" value="pm"></el-option>
                </el-select>  
                <!-- <span v-show="hasOperationNum>0" class="now_operation">已预约{{hasOperationNum}}</span>             -->
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="治疗地点">
                <el-autocomplete
                  class="popInput"
                  v-model="cosmetRegistration.operation_place"
                  :fetch-suggestions="operationplacelist"
                  placeholder="请输入内容"
                  @blur="saveSuggesion(1)"
                  @focus="updateLocal(1)"
                ></el-autocomplete>
              </el-form-item>
            </el-col>

          </el-col>
          <!-- <el-col :span="8">
          </el-col>-->
          <br />
          <el-col :span="4">
            <el-form-item label="操作医生">
              <el-autocomplete
                class="popInput"
                v-model="cosmetRegistration.operation_doctor"
                :fetch-suggestions="operationdoctorlist"
                placeholder="请输入内容"
                @blur="saveSuggesion(2)"
                @focus="updateLocal(2)"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="助理1">
              <el-autocomplete
                class="popInput"
                v-model="cosmetRegistration.assistant1"
                :fetch-suggestions="assistant1list"
                placeholder="请输入内容"
                @blur="saveSuggesion(3)"
                @focus="updateLocal(3)"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="4">
            <el-form-item label="助理2">
              <el-autocomplete
                class="popInput"
                v-model="cosmetRegistration.assistant2"
                :fetch-suggestions="assistant2list"
                placeholder="请输入内容"
                @blur="saveSuggesion(4)"
                @focus="updateLocal(4)"
              ></el-autocomplete>
            </el-form-item>
          </el-col> -->
          <el-col :span="4">
            <el-form-item label="治疗费用">
              <!-- <el-input v-model="cosmetRegistration.operation_fee" placeholder="请输入"></el-input> -->
              <el-autocomplete
                type="text"
                class="popInput"
                v-model="cosmetRegistration.operation_fee"
                :fetch-suggestions="operationfeelist"
                placeholder="请输入内容"
                @blur="saveSuggesion(5)"
                @focus="updateLocal(5)"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="登记者">
              <!-- <el-input v-model="cosmetRegistration.operation_fee" placeholder="请输入"></el-input> -->
              <el-autocomplete
                type="text"
                class="popInput"
                v-model="cosmetRegistration.record_person"
                :fetch-suggestions="recordpersonlist"
                placeholder="-默认为用户自己-"
                @blur="saveSuggesion(9)"
                @focus="updateLocal(9)"
              ></el-autocomplete>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="备注信息">
              <el-autocomplete
                class="popInput"
                v-model="cosmetRegistration.note"
                :fetch-suggestions="operationnotelist"
                placeholder="请输入内容"
                @blur="saveSuggesion(8)"
                @focus="updateLocal(8)"
              ></el-autocomplete>
            </el-form-item>
          </el-col>


          <el-col :span="3" class="btnBottom">
            <button
              @click.prevent="addCosmetRegistration"
              class="btn iconfont leftItemSubmit btn_newpatient"
              style="padding: 0"
              :disabled="hasMutate"
              :class="{'hasDIsabled':hasMutate}"
            >确定</button>
            <!-- <button
              @click.prevent="printConsent()"
              class="btn iconfont leftItemSubmit"
              style="padding: 0"
            >知情同意书1</button>
            <button
              class="btn iconfont leftItemSubmit"
              style="padding: 0"
              @click.prevent="printConsent2()"
            >知情同意书2</button> -->
          </el-col>

        </el-form>
        <iframe hidden ref="iframePDF"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
// api:addCosmetRegistration
import addCosmetRegistration from "../gql/addCosmetRegistration.gql";
// api:modifyCosmetRegistration
import setCosmetRegistration from "../gql/setCosmetRegistration.gql";
// return CosmetRegistration
import getCosmetRegistrationData from "../gql/getCosmetRegistrationData.gql";
// api:cosmetRegistrationByPatientDate, 是否在当天已经预约？ 
import cosmetRegistrationByPatientDate from "../gql/cosmetRegistrationByPatientDate.gql";
// api:cosmetRegistrationNumByDate, 查询指定日期手术预约数量,分时段上午和下午，返回数组长度为2
import cosmetRegistrationNumByDate from "../gql/cosmetRegistrationNumByDate.gql";

import gql from "graphql-tag";
import moment from "moment";
import position from "../race.js";
import saveLocal from "../utils/saveRegistration";
import printReportConsent from "../utils/printReportConsent.js";
let regData = /[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/;
export default {
  name: "electiveCosmetRegister",
  data() {
    return {
      cosmetRegistration: {
        patient_id: "",
        doctor_id: "",
        operation_name: "",
        operation_position_new: "",
        high_risk_factor: "",
        operation_date: "",
        operation_place: "",
        sign_doctor: "",
        operation_doctor: "",
        assistant1: "",
        assistant2: "",
        operation_fee: "",
        operation_status: "预约",
        record_person: "",
        operation_releinfo_id: "",
        am_pm:"",
        note:""
      },
      heightRisk: [
        { value: "手术部位", index: 0 },
        { value: "易损伤神经", index: 1 },
        { value: "血管", index: 3 }
      ],
      hasMutate: false, // 已经完成预约
      // positionOption: [],
      // newPosition: "",
      resetOperationDate: "",
      hasOperationNum:[0,0], // 当前已完成预约数量,上午和下午
      // 后台预设或者用户设置的项目名称
      operation_names: []
    };
  },
  mixins: [saveLocal, printReportConsent],
  created() {
    // // console.log(position.position.noDistinguish)
    // // console.log( Object.keys(position.position.noDistinguish))
    // let positionArray = position.position.noDistinguish;
    // let newPositionArray = [];
    // for (const A in positionArray) {
    //   if (positionArray.hasOwnProperty(A)) {
    //     let obj = {};
    //     obj.value = A;
    //     obj.label = A;
    //     obj.children = [];

    //     for (let i = 0; i < positionArray[A].length; i++) {
    //       let objChildren = {};
    //       objChildren.value = positionArray[A][i];
    //       objChildren.label = positionArray[A][i];
    //       obj.children.push(objChildren);
    //     }
    //     newPositionArray.push(obj);
    //   }
    // }
    // // console.log(newPositionArray)
    // this.positionOption = newPositionArray;
  },
  computed: {
    patient_id() {
      return this.$store.state.cosmetRegistrationPatientId;
    },
    opearClick() {
      return this.$store.state.cosmetRegistrationClearClick;
    },
    editObjId() {
      return this.$store.state.editcosmetRegistrationObjId;
    },
    operationElectiveId() {
      return Number(this.$store.state.cosmetRegistrationElectiveId);
    },
    editOperation() {
      return this.$store.state.editcosmetRegistration;
    },
    operationRelevantId() {
      return this.$store.state.cosmetRegistrationRelevantId;
    }
  },
  mounted() {
    if (this.opearClick) {
      this.reset();
    };
    this.getcosmetRegistrationLeft()
  },
  watch: {
    // "cosmetRegistration.operation_position_new"(newVal) {
    //   if (newVal) { 
    //     // let newString = [];
    //     // for (let i = 0; i < newVal.length; i++) {
    //     //   newString.push(newVal[i].join("-"));
    //     // }
    //     // this.newPosition = newString.join(",");
    //     this.newPosition = newVal;
    //   } else {
    //     this.newPosition = "";
    //   }
    // },
    "cosmetRegistration.operation_fee"(newVal) {
      if (newVal <= 0) {
        this.$set(this.cosmetRegistration, "operation_fee", "");
      }
    },
    'opearClick'(newVal) {
      if (newVal) {
        this.reset();
      }
    },
    async 'cosmetRegistration.operation_date'(newVal) {
      if (newVal) {
        await this.cosmetRegistrationNumByDate(newVal);
      } else {
        this.hasOperationNum = [0,0];
      }
    }
  },
  methods: {
    async reset() {
      //重置组件变量为default
      this.cosmetRegistration = {
        patient_id: "",
        doctor_id: "",
        operation_name: "",
        operation_position_new: "",
        high_risk_factor: "",
        operation_date: "",
        operation_place: "",
        sign_doctor: "",
        operation_doctor: "",
        assistant1: "",
        assistant2: "",
        operation_fee: "",
        operation_status: "预约",
        record_person: "",
        operation_releinfo_id: "",
        am_pm:"",
        note:""
      };
      this.hasMutate = false;
      this.resetOperationDate = "";
      this.hasOperationNum = [0,0];
      this.$store.commit("setcosmetRegistrationFormElectiveStatus", true);
      //根据已选预约登记ID，从后台获取数据并刷新页面
      //console.log("In ElectiveCosmetRegister, reset, this.operationElectiveId && this.editOperation:",this.operationElectiveId, this.editOperation);
      if (this.operationElectiveId && this.editOperation) {
        this.resetOperationDate = "";
        await this.getCosmetRegistration();
      }
    },
    // 根据 operationElectiveId 获取后台相应登记数据，并赋值给组件变量
    async getCosmetRegistration() {
      try {
        let res = await this.$apollo.query({
          query: getCosmetRegistrationData,
          variables: {
            id: this.operationElectiveId
          },
          fetchPolicy: "no-cache"
        });
        let newData = res.data.cosmetRegistration;
        
        // if (newData.operation_position) {
        //   let newArray1 = newData.operation_position.split(",");
        //   let newObj = [];
        //   for (let i = 0; i < newArray1.length; i++) {
        //     newObj.push(newArray1[i].split("-"));
        //   }
        //   this.cosmetRegistration = newData;
        //   this.$set(this.cosmetRegistration, "operation_position_new", newObj);
        // } else {
        //   this.cosmetRegistration = newData;
        //   this.$set(this.cosmetRegistration, "operation_position_new", "");
        // }
        this.cosmetRegistration = newData;
        // 数据库内的字段是 "operation_position" , 前端代码内的字段是 "operation_position_new"
        this.$set(this.cosmetRegistration, "operation_position_new", newData.operation_position);

        this.$set(
          this.cosmetRegistration,
          "operation_fee",
          `${newData.operation_fee * 0.01}`
        );
        this.resetOperationDate = moment(newData.operation_date).format(
          "YYYY-MM-DD"
        );

        //console.log("In ElectiveCosmetRegister, getCosmetRegistration:",this.cosmetRegistration);
      } catch (error) {
        console.log(error);
      }
    },
    // 新增或者修改登记；必选项：operation_name，operation_date，am_pm
    async addCosmetRegistration() {
      //console.log("In addCosmetRegistration，operation_name：",this.cosmetRegistration.operation_name," patient_id:",this.patient_id, " operationRelevantId:",this.operationRelevantId, "operationElectiveId:",this.operationElectiveId);
      console.log("In addCosmetRegistration, cosmetRegistration:",this.cosmetRegistration);
      if (this.cosmetRegistration.operation_name){
        if (this.patient_id && this.operationRelevantId) {
          if (this.cosmetRegistration.operation_date && this.cosmetRegistration.am_pm) {
            let isbofore = moment(this.cosmetRegistration.operation_date).isAfter(
              moment().add(-1, "days")
            );

            if (!isbofore) {
              if (this.operationElectiveId) {
                this.hasMutate = true;
                await this.setCosmetRegistration();
              } else {
                this.$message.error("无法预约过去时间");
              }
            } else {
              this.hasMutate = true;
              //存在ID，修改已有登记
              if (this.operationElectiveId) {
                //console.log("modify CosmetRegistration, operationElectiveId:",this.operationElectiveId)
                await this.setCosmetRegistration();
              } else {
                //新增登记
                //console.log("add new CosmetRegistration, operationElectiveId:",this.operationElectiveId)
                await this.mutateCosmetRegistration();
              }
            }
          } else {
            this.$message.error("请先选择预约日期及时段");
          }
        } else {        
          this.$message.error("请先添加患者信息和相关信息");
        }
      } else {
        this.$message.error("请先输入治疗项目");
      }
    },
    // 当天是否已经有预约
    async cosmetRegistrationByPatientDate() {
      try {
        let res = await this.$apollo.query({
          query: cosmetRegistrationByPatientDate,
          variables: {
            operation_date: this.cosmetRegistration.operation_date
              ? moment(this.cosmetRegistration.operation_date).format("YYYY-MM-DD") +
                " 17:00:00"
              : '"1000-01-01 00:00:00"',
            patient_id: this.patient_id
          },
          fetchPolicy: "no-cache"
        });
        // console.log(res.data.cosmetRegistrationByPatientDate);
        return res.data.cosmetRegistrationByPatientDate;
      } catch (error) {
        this.$message.error("请检查网络");
        return true;
      }
    },
    //当天上下午时段已经预约的数量[N1,N2]
    async cosmetRegistrationNumByDate(data) {
      try {
        //如果在日期选择之前，未设置项目，则日期设置失败
        //console.log("In cosmetRegistrationNumByDate,operation_name:",this.operation_name);
        if(this.cosmetRegistration.operation_name==""|| this.cosmetRegistration.operation_name==undefined){          
          this.$confirm(
            `请先选择操作项目!`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          ).then(async () => {
            
          }).catch(() => {              
            //console.log('取消');
          });
         
          this.cosmetRegistration.operation_date = "";
          this.hasOperationNum = [0,0];

        }else{
          //console.log("In cosmetRegistrationNumByDate,befor query");
          let res = await this.$apollo.query({
            query: cosmetRegistrationNumByDate,
            variables: {
              operation_date: moment(data).format("YYYY-MM-DD") + " 17:00:00",
              operation_name: this.cosmetRegistration.operation_name
            },
            fetchPolicy: "no-cache"
          });
          this.hasOperationNum = res.data.cosmetRegistrationNumByDate;
          //console.log("In cosmetRegistrationNumByDate, date:",moment(data).format("YYYY-MM-DD"), "hasOperationNum:", this.hasOperationNum);
        }

      } catch (error) {
        this.$message.error("请检查网络");
        this.hasOperationNum = [0,0];
      }
    },
    // 新增登记入口
    async mutateCosmetRegistration() {
      try {
        let hasOperaton = await this.cosmetRegistrationByPatientDate();
        if (hasOperaton) {
          this.$confirm(
            `该患者已预约过当天的项目，是否继续?`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          ).then(async () => {
            await this.mutateCosmetRegistration2();
          }).catch(() => {
              this.hasMutate = false;
              // console.log('取消');
            });
        } else {
          await this.mutateCosmetRegistration2();
        }
      } catch (error) {
        this.$message.error("请检查网络");
        console.log(error)
      }
    },
    // 新增登记实现
    async mutateCosmetRegistration2() {
      try {
        if (!this.$store.state.doctorDitail.id) {
          await this.getMe();
        }
        //console.log("Come into  mutateCosmetRegistration2");
        
        let query = {};
        query = {
          patient_id: this.patient_id,
          doctor_id: this.$store.state.doctorDitail.id,
          operation_name: this.cosmetRegistration.operation_name,
          operation_position: this.cosmetRegistration.operation_position_new,
          high_risk_factor: this.cosmetRegistration.high_risk_factor,
          operation_date: this.cosmetRegistration.operation_date
            ? moment(this.cosmetRegistration.operation_date).format("YYYY-MM-DD") +
            " 17:00:00"
            : '"1000-01-01 00:00:00"',
          operation_place: this.cosmetRegistration.operation_place,
          sign_doctor: this.cosmetRegistration.sign_doctor,
          operation_doctor: this.cosmetRegistration.operation_doctor,
          assistant1: this.cosmetRegistration.assistant1,
          assistant2: this.cosmetRegistration.assistant2,
          operation_fee: this.cosmetRegistration.operation_fee
            ? Number(this.cosmetRegistration.operation_fee) * 100
            : 0,
          operation_status: "预约",
          //如果没有设置该值，则默认为用户自己
          record_person: this.cosmetRegistration.record_person? this.cosmetRegistration.record_person: this.$store.state.doctorDitail.realname,
          operation_releinfo_id: this.operationRelevantId,
          am_pm: this.cosmetRegistration.am_pm,
          note: this.cosmetRegistration.note
        };
        //console.log("query:",query);
        let res = await this.$apollo.mutate({
          mutation: addCosmetRegistration,
          variables: query
        });

        this.$message.success("已预约成功");
        // this.$store.commit("sethasNewElective", true);
        // 触发登记列表更新
        //console.log("After mutateCosmetRegistration2, emit refreshCosmetRegistrationList");
        this.$root.$emit("refreshCosmetRegistrationList");
        await this.cosmetRegistrationNumByDate(this.cosmetRegistration.operation_date);
      } catch (error) {
        if (error.message.split(":")[1] === " Failed to fetch") {
          this.$message.error("请检查网络");
          this.hasMutate = false;
          return;
        }
        if (error.message.split(":")[1] === " 未配置该项目的预约人数") {
          this.$message.error("未配置预约人数，无法预约");
          this.hasMutate = false;
          return;
        }

        // 后台判断当日无可预约资源后，寻找新的可预约日期：
        // 消息格式约定：available 为返回的消息内容，其中newdate格式为"YEAR-MH-DY", am_pm为string；约定两个数据以@@相连
        // available = newdate + "@@" + tmp_time;

        //if (regData.test(error.message.split(":")[1])) 
        if( error.message.split(":")[1].search("@@")!=-1){
           console.log(error.message);
           let newdate = error.message.split(":")[1].split("@@")[0];
           let new_am_pm = error.message.split(":")[1].split("@@")[1];
           let new_am_pm_mesg = new_am_pm=="am"?"上午":"下午";
          //  this.$message.error(error.message.split(":")[1]);
          this.$confirm(
            `当前日期已约满，可预约到${newdate} ${new_am_pm_mesg}是否继续?`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
            .then(async () => {
              //更新日期和时段
              this.cosmetRegistration.operation_date = moment(
                newdate
              ).format("YYYY-MM-DD");
              this.cosmetRegistration.am_pm = new_am_pm;
              //重新提起新建登记请求
              await this.mutateCosmetRegistration();
              this.saveSuggesion(7);
            })
            .catch(() => {
              this.hasMutate = false;
              // console.log('取消');
            });
        } else {
          console.log(error);
          this.$message.error(error.message.split(":")[1]);
          this.hasMutate = false;
        }
      }
    },
    // 修改已经存在的登记信息
    async setCosmetRegistration() {
      try {
        if (!this.$store.state.doctorDitail.id) {
          await this.getMe();
        }
        let query = {};
        if (
          this.resetOperationDate ===
          moment(this.cosmetRegistration.operation_date).format("YYYY-MM-DD")
        ) {
          query = {
            id: this.operationElectiveId,
            patient_id: this.patient_id,
            doctor_id: this.$store.state.doctorDitail.id,
            operation_name: this.cosmetRegistration.operation_name,
            operation_position: this.cosmetRegistration.operation_position_new,
            high_risk_factor: this.cosmetRegistration.high_risk_factor,
            operation_place: this.cosmetRegistration.operation_place,
            sign_doctor: this.cosmetRegistration.sign_doctor,
            operation_doctor: this.cosmetRegistration.operation_doctor,
            assistant1: this.cosmetRegistration.assistant1,
            assistant2: this.cosmetRegistration.assistant2,
            operation_fee: this.cosmetRegistration.operation_fee
              ? Number(this.cosmetRegistration.operation_fee) * 100
              : 0,
            // operation_status: "预约",
            //如果没有设置该值，则默认为用户自己
            record_person: this.cosmetRegistration.record_person? this.cosmetRegistration.record_person: this.$store.state.doctorDitail.realname,
            //record_person: this.$store.state.doctorDitail.realname,
            operation_releinfo_id: this.operationRelevantId,
            am_pm: this.cosmetRegistration.am_pm,
            note: this.cosmetRegistration.note
          };
        } else {
          let isbofore = moment(this.cosmetRegistration.operation_date).isAfter(
            moment().add(-1, "days")
          );
          if (!isbofore) {
            this.$message.error("无法修改为过去时间");
            this.hasMutate = false;
            return;
          }else {
            query = {
              id: this.operationElectiveId,
              patient_id: this.patient_id,
              doctor_id: this.$store.state.doctorDitail.id,
              operation_name: this.cosmetRegistration.operation_name,
              operation_position: this.cosmetRegistration.operation_position_new,
              high_risk_factor: this.cosmetRegistration.high_risk_factor,
              operation_date: this.cosmetRegistration.operation_date
                ? moment(this.cosmetRegistration.operation_date).format("YYYY-MM-DD") +
                  " 17:00:00"
                : '"1000-01-01 00:00:00"',
              operation_place: this.cosmetRegistration.operation_place,
              sign_doctor: this.cosmetRegistration.sign_doctor,
              operation_doctor: this.cosmetRegistration.operation_doctor,
              assistant1: this.cosmetRegistration.assistant1,
              assistant2: this.cosmetRegistration.assistant2,
              operation_fee: this.cosmetRegistration.operation_fee
                ? Number(this.cosmetRegistration.operation_fee) * 100
                : 0,
              operation_status: "预约",
              //如果没有设置该值，则默认为用户自己
              record_person: this.cosmetRegistration.record_person? this.cosmetRegistration.record_person: this.$store.state.doctorDitail.realname,
              //record_person: this.$store.state.doctorDitail.realname,
              operation_releinfo_id: this.operationRelevantId,
              am_pm: this.cosmetRegistration.am_pm,
              note: this.cosmetRegistration.note
            };
          }
        }
        //console.log("修改已经存在的登记信息, query:",query);
        let res = await this.$apollo.mutate({
          mutation: setCosmetRegistration,
          variables: query
        });
        this.$message.success("数据已修改");
        this.hasMutate = true;
        // this.$store.commit("sethasNewElective", true);
        this.$root.$emit("refreshCosmetRegistrationList");
        await this.cosmetRegistrationNumByDate(this.cosmetRegistration.operation_date);
      } catch (error) {
        if (error.message.split(":")[1] === " Failed to fetch") {
          this.$message.error("请检查网络");
          this.hasMutate = false;
          return;
        }
        if (error.message.split(":")[1] === " 未配置该项目的预约人数") {
          this.$message.error("未配置预约人数，无法预约");
          this.hasMutate = false;
          return;
        }
        
        // 旧的方式为判断返回的信息内是否匹配日期的正则表达式
        //if (regData.test(error.message.split(":")[1])) 

        // 后台判断当日无可预约资源后，寻找新的可预约日期：
        // 消息格式约定：available 为返回的消息内容，其中newdate格式为"YEAR-MH-DY", am_pm为string；约定两个数据以@@相连
        // available = newdate + "@@" + tmp_time;
        if( error.message.split(":")[1].search("@@")!=-1){
           console.log(error.message);
           let newdate = error.message.split(":")[1].split("@@")[0];
           let new_am_pm = error.message.split(":")[1].split("@@")[1];
           let new_am_pm_mesg = new_am_pm=="am"?"上午":"下午";
          //  this.$message.error(error.message.split(":")[1]);
          this.$confirm(
            `当前日期已约满，可预约到${newdate} ${new_am_pm_mesg}是否继续?`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
            .then(async () => {
              // 更新日期和时段
              this.cosmetRegistration.operation_date = moment(
                newdate
              ).format("YYYY-MM-DD");
              this.cosmetRegistration.am_pm = new_am_pm;
              // 重新提起更新请求
              await this.setCosmetRegistration();
              this.saveSuggesion(7);
            })
            .catch(() => {
              console.log("取消");
              this.hasMutate = false;
            });
        } else {
          console.log(error);
          this.$message.error(error.message.split(":")[1]);
          this.hasMutate = false;
        }
      }
    },


    // 查询团队预约设置情况
    async getcosmetRegistrationLeft() {
        try {
          const res = await this.$apollo.query({
            query: gql`{
              me{
                id
                leader_id
              }
            }`,
            fetchPolicy: "no-cache",
          });          
          const res1 = await this.$apollo.query({
            query: gql`{
              getcosmetRegistrationLeft(leaderid: ${res.data.me.leader_id}){
                id,
                operation_name, 
                monday_am, 
                monday_pm, 
                tuesday_am, 
                tuesday_pm, 
                wednesday_am, 
                wednesday_pm, 
                thursday_am, 
                thursday_pm, 
                friday_am, 
                friday_pm, 
                saturday_am, 
                saturday_pm, 
                sunday_am, 
                sunday_pm
              }
            }`,
            fetchPolicy: "no-cache",
          });
          //console.log("In cosmetRegConfig, getcosmetRegistrationLeft:",res1.data.getcosmetRegistrationLeft);
          let tmp_table_data = [];
          let tmp_operation_names = [];
          if (res1.data.getcosmetRegistrationLeft) {
            const resData = res1.data.getcosmetRegistrationLeft;
            let tmp_length = resData.length;
            resData.forEach((tmp_item,tmp_index,resData) => {
                // this.configItem = {
                //     id: String(tmp_item.id),
                //     operation_name: String(tmp_item.operation_name), 
                //     // monday_am: String(tmp_item.monday_am),  
                //     // monday_pm: String(tmp_item.monday_pm), 
                //     // tuesday_am: String(tmp_item.tuesday_am), 
                //     // tuesday_pm: String(tmp_item.tuesday_pm), 
                //     // wednesday_am: String(tmp_item.wednesday_am), 
                //     // wednesday_pm: String(tmp_item.wednesday_pm), 
                //     // thursday_am: String(tmp_item.thursday_am), 
                //     // thursday_pm: String(tmp_item.thursday_pm), 
                //     // friday_am: String(tmp_item.friday_am), 
                //     // friday_pm: String(tmp_item.friday_pm), 
                //     // saturday_am: String(tmp_item.saturday_am), 
                //     // saturday_pm: String(tmp_item.saturday_pm), 
                //     // sunday_am: String(tmp_item.sunday_am), 
                //     // sunday_pm: String(tmp_item.saturday_pm) 

                // };
                //console.log("In cosmetRegConfig, configItem:", this.configItem);
                //tmp_table_data.push(this.configItem);   
                tmp_operation_names.push(String(tmp_item.operation_name));            
            });

            // this.formData = {
            //   monday: String(resData.monday),
            //   tuesday: String(resData.tuesday),
            //   wednesday: String(resData.wednesday),
            //   thursday: String(resData.thursday),
            //   friday: String(resData.friday),
            //   saturday: String(resData.saturday),
            //   sunday: String(resData.sunday),
            // };
            //this.leaderId = resData.id;
            //this.tableData = tmp_table_data;
            this.operation_names = tmp_operation_names;
          } else {
            //this.tableData = [];
            this.operation_names = [];
          }
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
    },


    async getMe() {
      try {
        let res = await this.$apollo.query({
          query: gql`
            {
              me {
                id
                realname
              }
            }
          `
        });
        let realname = res.data.me.realname;
        this.$store.commit("setMe", realname);
        localStorage.setItem("me", realname);
        this.$store.commit("setdoctorDitail", {
          id: res.data.me.id,
          realname: res.data.me.realname ? res.data.me.realname : ""
        });
      } catch (error) {
        this.$message.error("请检查网络后重试");
      }
    }
  }
};
</script>
<style lang="less">
.electiveCosmetRegister {
  .el-form-item__label {
    color: black;
    font-weight: 600;
  }
  .el-select,
  .el-cascader,
  .el-form-item__content {
    width: 100%;
  }
  .el-form-item {
    width: 100% !important;
    display: flex;
    margin-top: 10px;
    padding-left: 24px;
    box-sizing: border-box;
    margin-bottom: 0;
  }
  .el-form-item__content {
    flex: 1;
  }
  .el-input input {
    // min-height: 36px !important;
    height: 36px !important;
    width: 100%;
  }
  .el-cascader__tags {
    height: 32px !important;
    overflow-y: auto;
    padding-top: 2px;
    // margin: 1px 0 !important;
    box-sizing: border-box !important;
  }
  .el-date-editor {
    width: 100%;
  }
}
</style>
<style lang="less">
.electiveCosmetRegister {
  .line {
    width: 100%;
    height: 2px;
    background: #4ea3c0;
  }
  .nav {
    .title {
      display: flex;
      color: #4ea3c0;
      // height: 40px;
      line-height: 45px;
      i {
        text-indent: 50px;
        font-size: 30px;
      }
      p {
        text-indent: 10px;
        font-size: 18px;
      }
    }
  }
  .main {
    padding: 0 30px;
    box-sizing: border-box;
    .leftItemSubmit {
      height: 40px;
    }
    .btnBottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 55px;
      padding-left: 24px;
      box-sizing: border-box;
    }
  }
  .hasDIsabled {
    background: gray !important;
    cursor: not-allowed;
  }
  .popInput {
    width: 100%;
  }
  .operation_date{
    position: relative;
    .now_operation{
      position: absolute;
      right: 30px;
      background: #67c23a;
      color: white;
      border-radius: 4px;
      padding: 0 4px;
    }
  }
}
</style>
